/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)
import XDownloader from "./XDownloader";
import Gri from "./Gri";
import Animations from "./Animations";
import Slider from "./slider";
import GriExtraClass from "./GriExtraClass";
import Header from "./Header"
import Helper from "./Helper";

var downloaderInstance = null;
var headerInstance = null;


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  downloaderInstance = new XDownloader({
    downloadText: "XLS", //Can be empty if you want to use an icon instead
    backgroundColor: "e0f2fb", //Colored Cells Background
    backgroundClass: 'ns-backgroundcolor-dunkelblau', //Class of colored cells
    borderColor: '000000', //Color of border
    borderStyle: 'thin', // thin/dotted/medium/double/thick
    borderStyle2: 'thin', // thin/dotted/medium/double/thick
    headClass: 'head', //Class you want your columns based on. Will be bold in Excel
    boldClass: 'bline_bold', //Class for Bold text in Excel
    boldClass2: 'bline_bold_blue', //Class for Bold text in Excel
    borderClass: 'ns-borderbottom-line_black_solid', borderClass2: 'noline_space_small', rowBase: 2
  });

  headerInstance = new Header({
    menuSelector: ".js-menu",
    submenuSelector: '.menu__wrap--level-1',
    burgerSelector: '.js-toggle-menu',
    headerSelector: '.menu-main-wrap',
    menuItemLevel0Selector: '.menu__item--level-0.menu__item--has-children',
    burgerOpenClass: 'burger-open',
    submenuItemSelector: '.menu__item.menu__item--has-children:not(.menu__item--level-0)',
    menuItemSelector: '.menu__item--has-children',
  });

  new Gri();

  new Animations({
    targetQuery: '.ns-teaserbox'
  })

  new Slider({});

  new GriExtraClass({
    griClassSelector: 'span.top'
  });
});
